import { PostHog } from "posthog-js";
import {
  GetUserIfLoggedIn,
  IdentityState,
  SignOutOpts,
  getActiveOrganisation,
} from "contexts/identity-context";

export function getName(identity: IdentityState): string {
  if (!identity) {
    return "";
  }
  const organisation = getActiveOrganisation(identity);

  if (organisation) {
    return organisation.name;
  }
  return getFullName(identity);
}

export function getFullName(identity: IdentityState): string {
  const user = GetUserIfLoggedIn(identity);
  if (!user) {
    return "";
  }

  return `${user.firstName} ${user.lastName}`;
}

export async function logOut(
  signOut: (opts?: SignOutOpts) => Promise<void>,
  shutdown: () => void,
  posthog: PostHog,
  opts?: SignOutOpts
) {
  await signOut(opts);
  shutdown();
  posthog.capture("user_signed_out");
}
